module.exports = __webpack_public_path__ + "static/media/Popup-icon.0fb9aa3a.svg";